import { render, staticRenderFns } from "./reset-pwd.vue?vue&type=template&id=4d0d4bc6&scoped=true"
import script from "./reset-pwd.vue?vue&type=script&lang=js"
export * from "./reset-pwd.vue?vue&type=script&lang=js"
import style0 from "./reset-pwd.vue?vue&type=style&index=0&id=4d0d4bc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d4bc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0d4bc6')) {
      api.createRecord('4d0d4bc6', component.options)
    } else {
      api.reload('4d0d4bc6', component.options)
    }
    module.hot.accept("./reset-pwd.vue?vue&type=template&id=4d0d4bc6&scoped=true", function () {
      api.rerender('4d0d4bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/profile/components/reset-pwd.vue"
export default component.exports